import { Text, StyleSheet, TextStyle, StyleProp } from "react-native";
import { ms } from "./moderateScale";
import { Colors } from "@/constants/Colors";

export default function Heading({
  text,
  style,
}: {
  text: string;
  style?: StyleProp<TextStyle>;
}) {
  return <Text style={[styles.heading, style]}>{text}</Text>;
}

const styles = StyleSheet.create({
  heading: {
    fontSize: ms(20),
    fontWeight: "600",
    color: Colors.text,
  },
});
